import { attachmentApi } from '@/store/services/attachment.service'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useLoaderData } from 'react-router-dom'
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader
} from '@material-tailwind/react'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { Pill } from '@/shared/components/pill'
import { store } from '@/store'
import { AttachmentTableWithTabs } from '@/shared/components/attachments'
import { useAuthorization } from '@/hooks'
import { HasAccess } from '@permify/react-role'

export const ContractAttachments = () => {
  const { contract: currentContract } = useLoaderData()
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })
  const defaultSearchParams = {
    attachable_type: 'Contractor::Contract',
    attachable_id: currentContract.id
  }

  const { t } = useTranslation()

  const pillOptions = useMemo(() => {
    return [
      { label: t('contract.id'), value: currentContract.id },
      { label: t('company.name'), value: currentContract.company.name },
      { label: t('documentNumber.one'), value: currentContract.company.documentNumber }
    ]
  }, [currentContract])

  const getMore = async (searchParams) => {
    try {
      const {
        attachments = [], meta = {}
      } = await store.dispatch(
        attachmentApi.endpoints.getAttachments.initiate(`?${searchParams.toString()}`)
      ).unwrap()

      const currentPage = Number(searchParams.get('page'))
      const hasMore = currentPage < meta?.pagination?.total_pages

      return {
        attachments,
        hasMore
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    hasAccess('contract#attachments')
  }, [])

  return (
    <Dialog size='xl' className='h-4/5' open={true}>
      <DialogHeader>Detalle de documentos subidos</DialogHeader>

      <DialogBody className='overflow-hidden' style={{ height: 'inherit' }}>
        <div className='flex gap-3 mb-5'>
          {!!pillOptions.length &&
            pillOptions.map(({ value, label }) => (
              <Pill key={value} label={label} value={value} />
            ))}
        </div>

        <AttachmentTableWithTabs
          initialSearchParams={defaultSearchParams}
          getMore={getMore}
        />
      </DialogBody>

      <DialogFooter className='flex gap-3'>
        <LinkWithQuery to={generatePath('/contracts')}>
          <Button
            variant='outlined'
            color='white'
          >
            Volver
          </Button>
        </LinkWithQuery>

        <LinkWithQuery to={generatePath('/contracts/:id/attachments/upload', { id: currentContract.id })}>
          <Button>
            Añadir documento
          </Button>
        </LinkWithQuery>
      </DialogFooter>
    </Dialog>
  )
}
